import NiasJobList from "../Components/Dashboard/NiasJobs"

const NIASJobs = () => {
    return(
        <div className="px-6 my-8">
            <p>NIAS Jobs List</p>
            <NiasJobList/>
        </div>
    )
}

export default NIASJobs